import React, { FC, useState } from "react";
import { Grid, InputLabel, TextareaAutosize, Tooltip } from "@mui/material";
import { FormFieldProps } from "../../../utils/formFields";
import useStyles from "../model/styles";

const FormTextAreaField: FC<FormFieldProps> = (props) => {
  const classes = useStyles();

  const [isFocused, setIsFocused] = useState(false);

  const getBorderColor = () => {
    if (props?.error) return "1px solid red";
    if (isFocused) return "1px solid #02906f";
    return "1px solid #ccc"; // default gray
  };

  const inputRender = (isInGrid: boolean) => {
    return (
      <TextareaAutosize
        {...{
          ...props,
          maxRows: props.maxRows,
          maxLength: props.maxLength, // Add maxLength here
          style: {
            resize: "none",
            background: "#fff",
            borderRadius: props?.isRounded ? "50px" : "5px",
            width: "100%",
            padding: "10px", // Set padding for the textarea
            fontSize: "16px", // Set font size
            lineHeight: "1.5", // Set line height
            color: "#000", // Set text color
            boxSizing: "border-box", // Ensure padding is included in width
            border: getBorderColor(), // Conditionally set red border if error exists
            outline: "none", // Remove default outline
          },
          onFocus: (e: any) => {
            setIsFocused(true);
          },
          onBlur: (e: any) => {
            setIsFocused(false);
            props?.onBlur && props?.onBlur(e);
          },
          inputProps: {
            ...props?.InputProps,
            style: {
              ...props?.inputProps?.style,
              "& .MuiOutlinedInput-notchedOutline": {
                top: "-6px !important",
              },
            },
          },
        }}
        disabled={props?.editReadOnly}
        placeholder={props.placeholder}
        name={props?.id}
        minRows={props?.minRows}
      />
    );
  };

  return (
    <>
      {props?.label && !props?.inSingleGridForm ? (
        <>
          <Grid
            item
            xs={12}
            sm={props?.md ? (props?.firstColmd ? props?.firstColmd : 1.5) : 5}
            className={classes.labelBox}
            sx={{
              ...props?.GridLabelStyle,
            }}
          >
            <Tooltip title={props?.tooltipText || ""} arrow>
              <InputLabel
                sx={{
                  color: "#333333",
                  fontWeight: 600,
                  fontSize: "18px",
                  ...props.InputLabelProps?.sx,
                }}
                shrink
                htmlFor={props?.id}
              >
                {props?.label}
                {props?.isRequired && (
                  <span style={{ color: "red", fontWeight: 500 }}>*</span>
                )}
              </InputLabel>
            </Tooltip>
          </Grid>
          <Grid
            item
            xs={12}
            sm={props?.md ? props?.md : 7}
            style={{
              ...props?.GridFieldStyle,
              padding: "0px",
              marginTop: "16px",
            }}
          >
            {inputRender(true)}
          </Grid>
        </>
      ) : props?.label && props?.inSingleGridForm ? (
        <>
          <Grid
            item
            xs={12}
            sm={props?.md ? props?.md : 12}
            sx={{
              display: "block",
              alignItems: "center",
              gap: 2,
              ...props?.GridFieldStyle,
            }}
          >
            <Tooltip title={props?.tooltipText || ""} arrow>
              <InputLabel
                sx={{
                  color: "#637381",
                  fontWeight: 600,
                  fontSize: "16px",
                  textAlign: "left !important",
                }}
                shrink
                htmlFor={props?.id}
              >
                {props?.label}
                {props?.isRequired && (
                  <span style={{ color: "red", fontWeight: 500 }}>*</span>
                )}
              </InputLabel>
            </Tooltip>
            {inputRender(true)}
            {props?.textInfo && (
              <span style={{ color: "#637381", fontSize: "12px",marginLeft:'4px' }}>
                {props.textInfo}
              </span>
            )}
          </Grid>
        </>
      ) : (
        inputRender(false)
      )}
    </>
  );
};

export default FormTextAreaField;
